/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { StringHelper } from "../helpers/stringHelper";

declare let webOS: any;

export type NetworkState = {
  tetheringEnabled?: boolean;
  state: string;
};
export type NetworkWiredInfo = {
  [key: string]: string | boolean;
};
export interface INetwork {
  wifi: NetworkState;
  wifiDirect: NetworkState;
  wired: NetworkWiredInfo;
  isInternetConnectionAvailable: boolean;
  subscribed: boolean;
  offlineMode: string;
  returnValue: boolean;
}

export interface IWebOSErrorModel {
  errorCode: number;
  errorText: string;
}

// TODO Add rest of types for response
export class AppConfigWebOS {
  static get ApiUrl(): string {
    return StringHelper.toString(process.env.REACT_APP_API_URL);
  }

  static get DataProvider(): string {
    return StringHelper.toString(process.env.REACT_APP_DATA_PROVIDER);
  }

  static get DataPageSize(): number {
    return process.env.REACT_APP_DATA_PAGE_SIZE
      ? +process.env.REACT_APP_DATA_PAGE_SIZE
      : 12;
  }

  static get PaymentProvider(): string {
    return StringHelper.toString(process.env.REACT_APP_PAYMENT_PROVIDER);
  }

  static get AppKey(): string {
    return StringHelper.toString(process.env.REACT_APP_KEY);
  }

  static get AppName(): string {
    return StringHelper.toString(process.env.REACT_APP_NAME);
  }

  static get AppUrl(): string {
    return StringHelper.toString(process.env.REACT_APP_APP_URL);
  }

  static get AppConfigUrl(): string {
    return StringHelper.toString(process.env.REACT_APP_CONFIG_URL);
  }

  static get DeviceOrientation(): string {
    return StringHelper.toString(process.env.REACT_APP_FORCE_ORIENTATION);
  }

  static get Environment(): string {
    return StringHelper.toString(process.env.REACT_APP_ENV);
  }

  static get PlayerType(): string {
    return StringHelper.toString(process.env.REACT_APP_PLAYER_TYPE);
  }

  static get PlayerNativeSupportDisabled(): boolean {
    return false;
  }

  static get TenantOrigin(): string {
    return StringHelper.toString(process.env.REACT_APP_TENANT_ORIGIN_URL);
  }

  static get PlatformVersion(): string {
    return `${process.env.REACT_APP_VERSION}`;
  }

  static CheckWebOS(): boolean {
    const systemInfo = webOS.systemInfo();
    return (
      Object.keys(systemInfo).length !== 0 && systemInfo.constructor === Object
    );
  }

  static get AppLocalTimezone(): string {
    // TODO Test on TV with VPN
    webOS.service.request("luna://com.webos.settingsservice", {
      method: "getSystemSettings",
      parameters: {
        keys: ["localeInfo"],
      },
      onSuccess: (inResponse: any) => {
        const plainResult = JSON.stringify(inResponse);
        const results = JSON.parse(plainResult);
        return results.settings.localeInfo.timezone;
      },
      onFailure: () => {
        return;
      },
    });
    return "";
  }

  static getDeviceLocale = (callback: CallableFunction) => {
    // @ts-ignore
    if (this.CheckWebOS()) {
      const systemInfo = webOS.systemInfo();
      webOS.service.request("luna://com.webos.settingsservice", {
        method: "getSystemSettings",
        parameters: {
          keys: ["localeInfo"],
        },
        onSuccess: function (inResponse: any) {
          const plainResult = JSON.stringify(inResponse);
          const results = JSON.parse(plainResult);
          const language = results.settings.localeInfo.locales.UI.replace(
            "-",
            "_",
          );

          callback(`${language}`, `${systemInfo.country}`);
        },
        onFailure: function (inError: IWebOSErrorModel) {
          callback("[" + inError.errorCode + "]: " + inError.errorText);
          return;
        },
      });
    }
  };

  static get AppDevicePlatformVersion(): string {
    let osVersion;
    if (AppConfigWebOS.CheckWebOS()) {
      webOS.deviceInfo((device: any) => {
        osVersion = device.sdkVersion;
      });
    }

    return osVersion || "";
  }

  static networkHandler = (callback: CallableFunction) => {
    if (AppConfigWebOS.CheckWebOS()) {
      webOS.service.request("luna://com.palm.connectionmanager", {
        method: "getStatus",
        parameters: { subscribe: true },
        onSuccess: (inResponse: INetwork) => {
          if (typeof inResponse.subscribed != "undefined") {
            if (!inResponse.subscribed) {
              console.log("Failed to subscribe network state");
              return;
            }
          }
          callback(inResponse.isInternetConnectionAvailable);
        },
        onFailure: (inError: IWebOSErrorModel) => {
          console.log("Failed to get network state");
          console.log("[" + inError.errorCode + "]: " + inError.errorText);
          return;
        },
      });
    }
  };
}
